import axios from 'axios';
import { store } from '../store/store';
import { logoutUser } from '../store/actions/authActions';

const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json',
  },
};

const axiosInstance = axios.create(API_CONFIG);
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      const publicRoutes = ['/signin', '/signup', '/forgot-password', '/otp-verification', '/reset-password', '/google/callback'];
      
      if (!publicRoutes.includes(currentPath)) {
        store.dispatch(logoutUser(true));
        window.location.href = '/signin';
        return Promise.resolve({
          success: false,
          message: 'Redirecting to sign in...',
          status: 401,
        });
      }
    }

    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      return Promise.reject({
        message: 'Request timed out. Please try again.',
        status: 408,
        code: error.code,
        data: error.response?.data,
      });
    }

    if (!error.response) {
      return Promise.reject({
        message: error.message || 'Network error. Please check your connection.',
        status: null,
        code: error.code,
        data: null,
      });
    }

    return Promise.reject({
      message: error.response?.data?.error || error.response?.data?.message || 'Something went wrong',
      status: error.response?.status,
      data: error.response?.data,
      code: error.code,
    });
  }
);

export const apiInvoker = {
  get: (url, config = {}) => axiosInstance.get(url, config),
  post: (url, data, config = {}) =>
    (axiosInstance.post(url, data, config)),
  put: (url, data, config = {}) => axiosInstance.put(url, data, config),
  patch: (url, data, config = {}) => axiosInstance.patch(url, data, config),
  delete: (url, config = {}) => axiosInstance.delete(url, config),
};

export { axiosInstance };